import { useNavigate } from 'react-router-dom';

import { useGlobalHotkeys } from '@/ui/utilities/hotkey/hooks/useGlobalHotkeys';

type GoToPageHotkeyEffectProps = {
  hotkey: string;
  path: string;
};

export const GoToPageHotkeyEffect = ({
  hotkey,
  path,
}: GoToPageHotkeyEffectProps) => {
  const navigate = useNavigate();

  useGlobalHotkeys({
    keys: hotkey,
    callback: () => {
      void navigate(path);
    },
  });

  return null;
};
